// eslint-disable-next-line unicorn/no-unsafe-regex
export const emailRegex = /^\w+(?:[.-]?\w+)*@\w+(?:[.-]?\w+)*(?:\.\w{2,3})+$/;
